import {Component} from '@angular/core';

@Component({
  selector: 'number-ico',
  templateUrl: './number-ico.component.html'
})
export class NumberIcoComponent {
}
